// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "flight-38T3l flight-1gcv-";
var _3 = "flight_open-2ECUG";
var _4 = "info-31sND";
var _5 = "features-1nqsH";
var _6 = "features__items-1GGiN";
var _7 = "features__links-1pzpl";
var _8 = "feature-3KaCl";
var _9 = "feature__icon-1ivgt";
var _a = "feature__text-1tFZg";
var _b = "modal-10OJi";
export { _1 as "__esModule", _2 as "flight", _3 as "flight_open", _4 as "info", _5 as "features", _6 as "features__items", _7 as "features__links", _8 as "feature", _9 as "feature__icon", _a as "feature__text", _b as "modal" }
export default { "__esModule": _1, "flight": _2, "flight_open": _3, "info": _4, "features": _5, "features__items": _6, "features__links": _7, "feature": _8, "feature__icon": _9, "feature__text": _a, "modal": _b }
